import { Flex } from '@chakra-ui/react';
import Navigation from 'components/common/Layout/Header/Navigation';
import Logo from 'components/common/Layout/Header/Logo';
import { Link } from 'components/UI';
import { ConfiguratorQueryParams } from 'types/designAutomation/configurator';
import AppRoutes from 'constants/routes';

type HeaderProps = {
  queryParams?: ConfiguratorQueryParams;
};

const Header = ({ queryParams }: HeaderProps) => {
  if (queryParams?.product) return null;

  return (
    <Flex
      sx={{
        bg: 'linear-gradient(178deg,var(--chakra-colors-base1Colour-400),var(--chakra-colors-base1Colour-500) 500%)',
        py: 4,
        px: 10,
        h: '82px',
        alignItems: 'center',
      }}
    >
      <Flex alignItems="center" justifyContent="space-between" w="full">
        <Link to={AppRoutes.Landing}>
          <Logo />
        </Link>

        <Flex justifyContent="flex-end" alignItems="center">
          <Navigation />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Header;
